import { render } from "./CountUp.vue?vue&type=template&id=38ee6e92"
import script from "./CountUp.vue?vue&type=script&lang=js"
export * from "./CountUp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__